/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type Rule = {
    readonly id?: number;
    name: string;
    description?: string | null;
    readonly created_at?: string;
    readonly updated_at?: string;
    billing_type?: Rule.billing_type | null;
    bill_tc?: boolean | null;
    bill_pc?: boolean | null;
    rule_engine: number;
    clinic?: number | null;
}

export namespace Rule {

    export enum billing_type {
        GLOBAL = 'global',
        CLIENT = 'client',
        NONE = 'none',
    }


}
